<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Ingresos vs Gastos</strong>
          </div>
          <b-form>
            <b-form-group
              label="Desde"
              label-for="periodoDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="periodoDesdeMesNombre" 
                :options="meses" 
                class="mb-3 select-fecha select-fecha-mes">
                <template slot="first">
                  <option :value="null">Seleccione un mes</option>
                </template>
              </b-form-select>
              <b-form-select 
                v-model="periodoDesdeAnio" 
                :options="anios" 
                class="mb-3 select-fecha select-fecha-anio">
                <template slot="first">
                  <option :value="0">Seleccione un año</option>
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group
              label="Hasta"
              label-for="periodoHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="periodoHastaMesNombre" 
                :options="meses" 
                class="mb-3 select-fecha select-fecha-mes">
                <template slot="first">
                  <option :value="null">Seleccione un mes</option>
                </template>
              </b-form-select>
              <b-form-select 
                v-model="periodoHastaAnio" 
                :options="anios" 
                class="mb-3 select-fecha select-fecha-anio">
                <template slot="first">
                  <option :value="0">Seleccione un año</option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
// import helpers from '../../mixins/helpers';
import exportXlsBancos from '../../mixins/export_xls_bancos';

import moment from 'moment';

export default {
  name: 'BancosMovimientosRpt',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
    exportXlsBancos,
    // helpers
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      periodoDesdeMesNombre: null,
      periodoDesdeAnio: 0,
      periodoHastaMesNombre: null,
      periodoHastaAnio: 0,

      // fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      // fechaHasta: moment(new Date()).format('YYYY-MM-DD'),

      labelCols: 1,
      meses: [],
      anios: []
    }
  },
  created() {
    this.meses = this.getMeses();
    this.anios = this.getAniosPeriodo();

    let fecha = moment.utc(new Date()).format('YYYY-MM-DD')

    this.periodoDesdeMes= new Date(fecha).getMonth() + 1;
    this.periodoDesdeMesNombre= this.getMesNombre(this.periodoDesdeMes);
    this.periodoDesdeAnio= new Date(fecha).getFullYear();

    this.periodoHastaMes= new Date(fecha).getMonth() + 1;
    this.periodoHastaMesNombre= this.getMesNombre(this.periodoHastaMes);
    this.periodoHastaAnio= new Date(fecha).getFullYear();
  },  
  methods: {
    validate() {
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let fechaDesde = parseInt(this.periodoDesdeAnio).toString().trim()
          + '-' + this.getMesNumeroToString(this.periodoDesdeMesNombre).trim()
          + '-01';

      let fechaHasta = parseInt(this.periodoHastaAnio).toString().trim()
          + '-' + this.getMesNumeroToString(this.periodoHastaMesNombre).trim()
          + '-01';

      let params = {
        fechaDesde,
        fechaHasta,
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('bancosmovimientos/getRptIngresosGastos', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptIngresosGastos = this.$store.getters['bancosmovimientos/rptIngresosGastos'];

            if (rptIngresosGastos) {
              if (rptIngresosGastos.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              this.exportXLSRptIngresosGastos(rptIngresosGastos);
            } else {
              this.showModalMsj('No hay datos para exportar.', null, null, 'light');
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    goBack() {

    },
  },
}
</script>

<style>
</style>
